// extracted by mini-css-extract-plugin
export default {"Lens":"Lens_Lens__wB8km","lens-icon":"Lens_lens-icon__WvjLS"};